import { styled } from "@styles";

export const Wrapper = styled.div``;

export const Title = styled.h1`
  font-weight: 300;
  font-size: 2rem;
  text-align: center;
`;

export const DetailText= styled.p`
  text-align: center;
`;

export const Icon = styled.img`
  width: 100%;
`;